import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';

export default function Founder() {
  return (
    <section className="py-24 bg-[#0f172a] text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          
          {/* Image Side */}
          <motion.div 
            className="relative"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            {/* Professional Frame Treatment */}
            <div className="relative z-10 rounded-2xl overflow-hidden border-8 border-slate-800 shadow-2xl">
              <img 
                src="/images/founder.png" 
                alt="Ashimwe Ivan - Founder" 
                className="w-full h-[500px] object-cover grayscale hover:grayscale-0 transition-all duration-700"
              />
            </div>
            {/* Decorative Orange Accent Box */}
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-gh-orange/20 -z-0 rounded-2xl border border-gh-orange/30"></div>
          </motion.div>

          {/* Text Side */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <Quote className="text-gh-orange mb-6 opacity-50" size={48} />
            <h2 className="text-gh-orange font-bold tracking-widest text-sm mb-2 uppercase">Our Founder</h2>
            <h3 className="text-4xl md:text-5xl font-black mb-8 leading-tight text-white">
              Driven by <span className="text-gh-orange">Experience</span>, Led by Love.
            </h3>
            
            <div className="space-y-6 text-slate-300 text-lg leading-relaxed font-light">
              <p>
                The mission of Giving Hands is not just a project for <span className="text-white font-bold">Ashimwe Ivan</span>; it is the culmination of a life once defined by the same shadows our children face today. 
              </p>
              <p>
                Growing up in the depths of poverty and facing abandonment at a tender age, Ivan understood the hollow ache of hunger and the weight of being forgotten by the world. For years, he navigated the harsh realities of survival alone, until a hand reached out to offer him a chance at a future.
              </p>
              <p>
                "I know what it means to wait for a miracle that doesn't seem to come," Ivan says. Having been pulled from the brink himself, he dedicated his life to ensuring that no child in Mityana—especially those with disabilities—would ever have to walk that lonely path again.
              </p>
            </div>

            <div className="mt-10 pt-8 border-t border-slate-800">
              <p className="text-2xl font-serif italic text-white">Ashimwe Ivan</p>
              <p className="text-gh-orange font-bold text-sm tracking-widest uppercase mt-1">Founder & Executive Director</p>
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
}